import $ from "jquery"
import _ from 'underscore'
import BaseReportPDFPreviewLightboxController from "../pdf/PDFPreviewLightboxController";
import PDFSettingsPreview from "./PDFSettingsPreview"
import ParametersFormattingStrategy from "./ParametersFormattingStrategy"
import OvertimeReportStore from './OvertimeReportStore'

const PDFPreviewLightboxController = function(){};

PDFPreviewLightboxController.prototype = _.create(BaseReportPDFPreviewLightboxController.prototype, {

    _initPdfSettingsPreview: function(elementsIdPrefix)
    {
        this.pdfSettingsPreview = new PDFSettingsPreview($(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix, this.eventNamespace).init();
    },

    createFormattingStrategy: function () {
        return new ParametersFormattingStrategy().init(
            this._getSelectorsData(),
            this.dateFormat,
            this.productSettingsValidator,
            this.reportRightsValidator,
            ATReportsStore.getReportAuthorizationInfo()
        )
    },
    
    getStore: function()
    {
        return OvertimeReportStore;
    },

    _getSelectedParameters: function()
    {
        var reportParams = this.getStore().getReportParams();
        return {
            dateParameters: {
                dateRangeSelection : reportParams.dateRangeSelection
            },
            userSelection: reportParams.userSelection,
            firstGroupingLevel: reportParams.firstGroupingLevel,
            secondGroupingLevel: reportParams.secondGroupingLevel,
            columnsConfig: reportParams.columnsConfig
        }
    },

    _getSelectorsData: function()
    {
        var store = this.getGeneralStore();
        return {
            users: store.getVisibleUsers(),
            userGroupsEnabled: store.getUserGroupsEnabled(),
            timeZoneGroupsEnabled: store.getTimeZoneGroupsEnabled(),
            userGroups: store.getUserGroups(),
            timeZoneGroups: store.getTimeZoneGroups(),
            manageableUserIds: ATReportsStore.getManageableUserIds()
        }
    }
});

export default PDFPreviewLightboxController


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/PDFPreviewLightboxController.js